"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _utils_1 = require("@utils");
const _theme_1 = __importDefault(require("@theme")); // Component
var ArticleProgress = function ArticleProgress(_ref) {
    var children = _ref.children, className = _ref.className;
    var pageOffset = _utils_1.useScrollPosition();
    var _React$useState = react_1.default.useState(0), bottomOfArticle = _React$useState[0], setBottomOfArticle = _React$useState[1];
    var progressBar = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        // We're setting a timer because, if we check the article height immediately, it won't account for images.
        // If images are long-loading, this will be off by a bit.
        // TODO: it would be really smart to use an all-images onLoaded trigger, but strikes me as hell to implement.
        var bottomOfArticleFinder = window.setTimeout(function () {
            var bottomOfArticleMarker = document.getElementById('bottomOfArticle');
            if (!bottomOfArticleMarker)
                return;
            setBottomOfArticle(bottomOfArticleMarker.offsetTop);
        }, 500);
        return function () {
            return window.clearTimeout(bottomOfArticleFinder);
        };
    }, []);
    var progress = _utils_1.ternaryClamp(0, pageOffset.y / bottomOfArticle * 100, 100);
    var jump = function jump(e) {
        var _progressBar$current, _progressBar$current2;
        if (!progressBar)
            return;
        var progressBarLeftPos = (progressBar === null || progressBar === void 0 ? void 0 : (_progressBar$current = progressBar.current) === null || _progressBar$current === void 0 ? void 0 : _progressBar$current.getBoundingClientRect().left) || 0;
        var positionInBar = e.clientX - progressBarLeftPos;
        var progressBarWidth = (progressBar === null || progressBar === void 0 ? void 0 : (_progressBar$current2 = progressBar.current) === null || _progressBar$current2 === void 0 ? void 0 : _progressBar$current2.getBoundingClientRect().width) || 1;
        var percentageOfArticle = positionInBar / progressBarWidth;
        var positionInWindow = Math.round(bottomOfArticle * percentageOfArticle);
        window.scrollTo({
            left: 0,
            top: positionInWindow,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        ref: progressBar,
        onClick: function onClick(event) {
            return jump(event);
        },
        className: className + " shiftable"
    }, /*#__PURE__*/ react_1.default.createElement(Bar, {
        progress: progress
    }), /*#__PURE__*/ react_1.default.createElement(Copy, null, /*#__PURE__*/ react_1.default.createElement("p", null, children)));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "ArticleProgress__Wrapper",
    componentId: "kstz1k-0"
})(["position:relative;display:grid;grid-auto-flow:column;height:100%;width:100%;"]);
var Bar = styled_components_1.default.div.attrs(function (props) {
    return {
        style: {
            transform: "translateX(" + (props.progress - 100) + "%)"
        }
    };
}).withConfig({
    displayName: "ArticleProgress__Bar",
    componentId: "kstz1k-1"
})(["z-index:3;position:absolute;bottom:0;background:", ";width:100%;height:2px;will-change:transform;pointer-events:none;"], _theme_1.default.palette.brown);
var Copy = styled_components_1.default.div.withConfig({
    displayName: "ArticleProgress__Copy",
    componentId: "kstz1k-2"
})(["z-index:5;position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:0 24px;& p{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", "}"], _theme_1.default.type.labelSmall); // Typing
exports.default = ArticleProgress;
